import React from 'react';
import './InboundCallBox.css';
const InboundCallBox = ({
  inboundCallText,
  inboundCallNumber
}: {
  inboundCallText: string | undefined;
  inboundCallNumber: string | undefined;
}) => {
  return (
    <div className="pushRight inboundCallBox" style={{ display: 'none' }}>
      <div className="inboundCallInfo makeFlex">
        <div className="inboundCallText font14 latoBold makeFlex  vrtlCenter2 lineHeight16">
          {inboundCallText}
        </div>
        <div className="inboundCallNumberArea">
          <span className="inboundCallNumberText makeFlex  vrtlCenter2 latoBold">
            {inboundCallNumber}
          </span>
        </div>
      </div>
    </div>
  );
};

export default InboundCallBox;
